var _line, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 9,
    viewBox: "0 0 66 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 4,
    x2: 63,
    y2: 4,
    stroke: "#515158"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_1346)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7641 1.76426C60.8943 1.63408 61.1054 1.63408 61.2355 1.76426L63.2355 3.76426C63.3657 3.89443 63.3657 4.10549 63.2355 4.23566L61.2355 6.23566C61.1054 6.36584 60.8943 6.36584 60.7641 6.23566C60.634 6.10549 60.634 5.89443 60.7641 5.76426L62.5284 3.99996L60.7641 2.23566C60.634 2.10549 60.634 1.89443 60.7641 1.76426Z",
    fill: "#515158"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_1346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(58)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.1db7964f2c1a3f2c3c477e334c79ca67.svg";
export { ForwardRef as ReactComponent };